import { Component } from '@angular/core';

@Component({
  selector: 'swb-certs',
  templateUrl: './certs.component.html'
})
export class CertsComponent {

  public certQuery = '';
  public grantQuery = '';

  public filterCerts(query: string): void {
    this.certQuery = query;
  }

  public filterGrants(query: string): void {
    this.certQuery = query;
  }

}
